import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/ISACI2025.vue'
import Login from '../views/Login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: false } // 首页不需要登录
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false } // 登录页面不需要登录验证
  },
  {
    path: '/MettingIndex',
    name: 'MettingIndex',
    component: () => import(/* webpackChunkName: "metting-index" */ '../views/MettingIndex.vue'),
  },
  {
    path: '/announcements',
    name: 'Announcements',
    component: () => import(/* webpackChunkName: "announcements" */ '../views/Announcements.vue')
  },
  {
    path: '/registration',
    name: 'Registration',
    component: () => import(/* webpackChunkName: "registration" */ '../views/Registration.vue')
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import(/* webpackChunkName: "profile" */ '../views/Profile.vue')
  },
  {
    path: '/session-list',
    name: 'SessionList',
    component: () => import(/* webpackChunkName: "session-list" */ '../views/SessionList.vue')
  },
  {
    path: '/my-abstracts',
    name: 'MyAbstracts',
    component: () => import(/* webpackChunkName: "my-abstracts" */ '../views/MyAbstracts.vue')
  },
  {
    path: '/invoices',
    name: 'Invoices',
    component: () => import(/* webpackChunkName: "invoices" */ '../views/Invoices.vue')
  },
  {
    path: '/registration-slip',
    name: 'RegistrationSlip',
    component: () => import(/* webpackChunkName: "registration-slip" */ '../views/RegistrationSlip.vue')
  },
  {
    path: '/proof-attendance',
    name: 'ProofAttendance',
    component: () => import(/* webpackChunkName: "proof-attendance" */ '../views/ProofAttendance.vue')
  },
  {
    path: '/schedule',
    name: 'Schedule',
    component: () => import(/* webpackChunkName: "schedule" */ '../views/Schedule.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import(/* webpackChunkName: "contact" */ '../views/Contact.vue')
  },
  {
    path: '/create-account',
    name: 'CreateAccount',
    component: () => import(/* webpackChunkName: "create-account" */ '../views/CreateAccount.vue')
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import(/* webpackChunkName: "forgot-password" */ '../views/ForgotPassword.vue')
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: () => import(/* webpackChunkName: "change-password" */ '../views/ChangePassword.vue')
  },
  {
    path: '/my-sessions',
    name: 'MySessions',
    component: () => import(/* webpackChunkName: "my-sessions" */ '@/views/MySessions.vue')
  },
  {
    path: '/session-details/:id',
    name: 'SessionDetails',
    component: () => import(/* webpackChunkName: "session-details" */ '@/views/SessionDetails.vue')
  },
  {
    path: '/abstract-details/:id',
    name: 'AbstractDetails',
    component: () => import(/* webpackChunkName: "abstract-details" */ '@/views/AbstractDetails.vue')
  },
  {
    path: '/member-registration',
    name: 'MemberRegistration',
    component: () => import(/* webpackChunkName: "member-registration" */ '@/views/MemberRegistration.vue')
  },
  {
    path: '/payment',
    name: 'Payment',
    component: () => import(/* webpackChunkName: "payment" */ '@/views/payment.vue')
  },
  {
    path: '/ISACI2025',
    name: 'AOGS2025',
    component: () => import(/* webpackChunkName: "aogs2025" */ '@/views/ISACI2025.vue'),
    meta: { requiresAuth: false } // 不需要登录验证
  },
  {
    path: '/meetings/registration',
    name: 'MettingRegistration',
    component: () => import(/* webpackChunkName: "meeting-registration" */ '@/views/MettingRegistration.vue'),
    meta: { requiresAuth: false } // 不需要登录验证
  },
  {
    path: '/meetings/information',
    name: 'Information',
    component: () => import(/* webpackChunkName: "information" */ '@/views/Information.vue'),
    meta: { requiresAuth: false } // 不需要登录验证
  },
  {
    path: '/official',
    name: 'OfficialIndex',
    component: () => import(/* webpackChunkName: "official-index" */ '@/views/OfficialWEB/Index.vue'),
    meta: { requiresAuth: false } // 不需要登录验证
  },
  {
    path: '/official/nondestructive-testing',
    name: 'NondestructiveTesting',
    component: () => import(/* webpackChunkName: "nondestructive-testing" */ '@/views/OfficialWEB/NondestructiveTesting.vue'),
    meta: { requiresAuth: false } // 不需要登录验证
  },
  {
    path: '/official/medical-imaging',
    name: 'MedicalImaging',
    component: () => import(/* webpackChunkName: "medical-imaging" */ '@/views/OfficialWEB/MedicalImaging.vue'),
    meta: { requiresAuth: false } // 不需要登录验证
  },
  {
    path: '/official/geophysical',
    name: 'Geophysical',
    component: () => import(/* webpackChunkName: "geophysical" */ '@/views/OfficialWEB/Geophysical.vue'),
    meta: { requiresAuth: false } // 不需要登录验证
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 自动处理懒加载 Chunk 失效（常见于热更新后旧路由映射仍在内存中）
router.onError((error) => {
  const isChunkLoadError = /Loading chunk .* failed|ChunkLoadError/i.test(error && error.message)
  if (isChunkLoadError) {
    // 强制刷新获取最新运行时代码与分片映射
    try {
      window.location.reload()
    } catch (e) {
      // 兜底
      const currentPath = (router.currentRoute && router.currentRoute.fullPath) || '/'
      window.location.href = currentPath
    }
  }
})

export default router 